import React from "react";

const AccessError = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
      }}
    >
      <h3 style={{ color: "red" }}>
        You do not have permission to access this application
      </h3>
    </div>
  );
};

export default AccessError;
